<mat-toolbar class="navbar">
  @if (isUserLoggedIn) {
    <button mat-icon-button class="menu-button" (click)="toggleSidenav()"><mat-icon>menu</mat-icon></button>
  }

  <a routerLink="/home">
    <img src="../../../assets/images/Logo.PNG" class="logo">
  </a>

  <span class="example-spacer"></span>
</mat-toolbar>

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #sidenav mode="side" [opened]="showSidenav">
    <mat-nav-list>
      <a mat-list-item style="border-radius: 0px;" routerLinkActive="mdc-list-item--activated" routerLink="home">Home</a>

      @if (getLoggedInUserRole == 'Admin') {
        @for (route of adminRoutes | keyvalue; track route) {
          <a mat-list-item style="border-radius: 0px;" routerLink="{{route.key}}"
            routerLinkActive="mdc-list-item--activated"
            >
            {{route.value}}
          </a>
        }
      }

      @if (getLoggedInUserRole == 'Underwriter') {
        @for (route of routes | keyvalue; track route) {
          <a mat-list-item style="border-radius: 0px;" routerLink="{{route.key}}"
            routerLinkActive="mdc-list-item--activated"
            >
            {{route.value}}
          </a>
        }
      }

    </mat-nav-list>

    <button mat-flat-button class="logout-button" style="border-radius: 0px;" (click)="logout()">Logout</button>
  </mat-sidenav>

  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

